import styled from 'styled-components';

export const DisabledDropdownOption = styled.div`
  display: flex;
  justify-content: space-between;
`;
